import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from '../components/Loader.js'
import { registerOwner, logoutOwner } from '../actions/ownerActions.js'
import FormContainer from '../components/FormContainer.js'
import { OWNER_REGISTER_RESET } from '../constants/ownerConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import { CountrySelect } from 'react-country-state-city'
import 'react-country-state-city/dist/react-country-state-city.css'

// Register Screen
const BusinessRegisterScreen = () => {
  const { theme } = useContext(ThemeContext)
  // State Hooks
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [bname, setBname] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [country, setCountry] = useState('')
  const [mailcode, setMailcode] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState(null)

  // Redux Hooks
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputRef = useRef()

  // Get owner register state from Redux store
  const ownerRegister = useSelector((state) => state.ownerRegister)
  const { loading, error, success, ownerInfo } = ownerRegister

  // Effect Hook
  useEffect(() => {
    if (ownerInfo && !loading) {
      dispatch(logoutOwner())
      navigate('/ownerlogin')
    } else {
      dispatch({ type: OWNER_REGISTER_RESET })
      inputRef.current.focus()
    }
  }, [navigate, ownerInfo, dispatch, loading, success])

  // Form Submit Handler
  const submitHandler = (e) => {
    e.preventDefault()

    const ownerinfo = {
      fname,
      lname,
      email,
      phone,
      bname,
      address,
      city,
      state,
      country,
      mailcode,
      password
    }

    if (
      fname === '' ||
      lname === '' ||
      email === '' ||
      phone === '' ||
      bname === '' ||
      address === '' ||
      city === '' ||
      state === '' ||
      country === '' ||
      mailcode === ''
    ) {
      setMessage('Please enter all fields')
      return
    }

    // Password validation
    if (password !== confirmPassword) {
      setMessage('Passwords do not match')
      return
    }

    if (
      password.length < 6 ||
      (confirmPassword.length < 6 && password !== '' && confirmPassword !== '')
    ) {
      setMessage('Password must be at least 6 characters')
      return
    }

    if (password === '' || confirmPassword === '') {
      setMessage('Password cannot be empty')
      return
    }

    if (
      password === confirmPassword &&
      (password !== '' || confirmPassword !== '') &&
      password.length >= 6 &&
      confirmPassword.length >= 6
    ) {
      setMessage('Registration Successful')
      dispatch(registerOwner(ownerinfo))
      setTimeout(() => {
        setMessage(null)
        navigate('/ownerlogin')
      }, 2000)
    }
  }

  return (
    <FormContainer>
      <h3 className='my-2'>Business Account Register</h3>
      {message &&
        password !== confirmPassword &&
        password.length >= 6 &&
        confirmPassword.length >= 6 &&
        password.length >= 6 &&
        confirmPassword.length >= 6 && (
          <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

      {message &&
        password === confirmPassword &&
        password !== '' &&
        password.length >= 6 &&
        confirmPassword.length >= 6 && (
          <Alert variant='success' dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

      {message && (password.length < 6 || confirmPassword.length < 6) && (
        <Alert variant='warning' dismissible onClose={() => setMessage(null)}>
          {message}
        </Alert>
      )}

      {message && (password === '' || confirmPassword === '') && (
        <Alert variant='warning' dismissible onClose={() => setMessage(null)}>
          {message}
        </Alert>
      )}

      {/* {error && <Message variant='danger'>{error}</Message>} */}

      {error && (
        <Alert variant='danger' dismissible onClose={() => setMessage(null)}>
          {error}
        </Alert>
      )}

      {loading && <Loader />}

      <Form onSubmit={submitHandler}>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='fname'>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                ref={inputRef}
                type='fname'
                autoFocus
                placeholder='First Name'
                value={fname}
                onChange={(e) => setFname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='lname'>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type='lname'
                placeholder='Last Name'
                value={lname}
                onChange={(e) => setLname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Email'
                autoComplete='on'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='phone'>
              <Form.Label>Phone Number</Form.Label>
              <PhoneInput
                placeholder='Enter phone number'
                value={phone}
                onChange={setPhone}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='bname'>
              <Form.Label>Business Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Business Name'
                value={bname}
                onChange={(e) => setBname(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='address'>
              <Form.Label>Address</Form.Label>
              <Form.Control
                type='address'
                placeholder='Address'
                autoComplete='on'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='city'>
              <Form.Label>City</Form.Label>
              <Form.Control
                type='city'
                placeholder='City'
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='state'>
              <Form.Label>State</Form.Label>
              <Form.Control
                type='state'
                placeholder=' State'
                value={state}
                onChange={(e) => setState(e.target.value)}
                required
              />
              {/* <StateSelect
                countryid={country?.id}
                type='state'
                placeholder='Select State'
                autoComplete='on'
                defaultValue={state}
                // value={state}
                onChange={(state) => setState(state.name)}
                // onTextChange={(_txt) => console.log(_txt)}
                required
              /> */}
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='country'>
              <Form.Label>Country</Form.Label>
              <Form.Control
                type='country'
                placeholder='Country'
                autoComplete='on'
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                required
              />
              {/* <CountrySelect
                type='country'
                placeHolder='Select Country'
                autoComplete='on'
                containerClassName='themed-country-select'
                inputClassName='themed-country-input'
                // value={country}
                onChange={(country) => setCountry(country.name)}
                // onTextChange={(_txt) => console.log(_txt)}
                required
              /> */}
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='mailcode'>
              <Form.Label>Mail Code</Form.Label>
              <Form.Control
                type='mailcode'
                placeholder='Mail Code'
                value={mailcode}
                onChange={(e) => setMailcode(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-1'>
          <Col>
            <Form.Group className='mb-2' controlId='password'>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-2' controlId='confirmPassword'>
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type='password'
                placeholder='(6 or more characters)'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Button
          type='submit'
          variant='outline-primary'
          style={{
            borderColor: theme.accent,
            color: theme.accent,
            backgroundColor: 'transparent'
          }}
        >
          Register
        </Button>
        <Button
          as={Link}
          to='/ownerlogin'
          variant='outline-primary'
          style={{
            borderColor: theme.accent,
            color: theme.accent,
            backgroundColor: 'transparent'
          }}
        >
          Login Here
        </Button>
      </Form>

      <Row className='py-1'>
        <Col></Col>
      </Row>
    </FormContainer>
  )
}

export default BusinessRegisterScreen
